module.exports = __webpack_public_path__ + "3c75efed86515aadc5c45e9396c286b3.png";